import React from 'react';

const HomeAbout = () => {
  return (
    <div className="about-section-1 relative flex flex-col items-start ">
      <div className="glass-effect glass-effect mx-8 text-white lg:mx-80">
        <h1 className="py-6 text-4xl font-bold md:py-12 md:text-6xl lg:py-12 lg:text-6xl">ABOUT US</h1>
        <p className=" text-xl font-thin md:py-12 md:text-2xl  lg:py-12 lg:text-2xl">
          The IEEE Information Theory Society at VIT is a newly established student chapter that explores the latest
          advancements in information theory to tackle modern-day challenges. We provide a nurturing environment for
          fresh ideas and innovative thinking, empowering individuals to make a difference. Our chapter organizes
          technical events, workshops, and delivers high-quality projects to partners and collaborators. We inspire and
          shape curious minds, helping them overcome present-day challenges and achieve success.
        </p>
      </div>
    </div>
  );
};

export default HomeAbout;
